// extracted by mini-css-extract-plugin
export default {"root_nothing":"ErrorBoundary_root_nothing__cg+zm"};